import React, { useRef, useState } from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import Text from '../../../../global/text/text';
import ConnectionGroupDetailsPopup from '../../../../_events/_manage-event/shared/connection-groups-list/connection-group-detail-popup/connection-group-detail-popup';
import { IConnectionTemplateConnectionGroupDTO, TConnection } from '../../../../../api/blueprints/connection.template.types';
import { ConnectionGroupsPassportPreviewViewModel } from '../../../../_events/_manage-event/shared/connection-groups-list/connection-groups-passport-preview/connection-group-passport-preview.viewmodel';

export interface IConnectionTemplateConnectionGroupListItemProps {
    connectionGroupsPassportPreviewViewModel: ConnectionGroupsPassportPreviewViewModel;
    group: IConnectionTemplateConnectionGroupDTO;
    editButtonText: JSX.Element;
    orderedConnections: (group: IConnectionTemplateConnectionGroupDTO) => TConnection[];
    onEditGroup: (group: IConnectionTemplateConnectionGroupDTO) => void;
    isSelected: boolean;
};

export const ConnectionTemplateConnectionGroupListItem = observer((props: IConnectionTemplateConnectionGroupListItemProps): JSX.Element => {
    const {
        connectionGroupsPassportPreviewViewModel,
        group,
        editButtonText,
        orderedConnections,
        onEditGroup,
        isSelected,
    } = props;
    const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false);
    const listItemRef = useRef(null);

    const onTogglePopover = (): void => {
        setIsPopoverOpen(prev => !prev);
    };

    return (
        <>
            <div
                className={classnames('connection-list__item connection-list__item--with-hover', {
                    'connection-list__item--active': isPopoverOpen || isSelected
                })}
                ref={listItemRef}
                onClick={onTogglePopover}
            >
                <Text tag='p' message={group.label} withEllipsis />
            </div>
            <div className='connection-item-popover'>
                <ConnectionGroupDetailsPopup
                    isPopoverOpen={isPopoverOpen}
                    closePopup={() => {
                        setIsPopoverOpen(false);
                    }}
                    listItemRef={listItemRef}
                    onEditGroup={onEditGroup}
                    orderedConnections={templateGroup => orderedConnections(templateGroup as IConnectionTemplateConnectionGroupDTO)}
                    group={group}
                    editButtonText={editButtonText}
                    editGroupPermission={true}
                    connectionGroupsPassportPreviewViewModel={connectionGroupsPassportPreviewViewModel}
                />
            </div>
        </>
    );
});
